import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';
import PropTypes from 'prop-types';
import React, {useCallback, useRef, useState} from 'react';
import Autosuggest from 'react-autosuggest';

import './styles.css';
import Avatar from '../../../../../../components/Avatar';
import KeyCode from '../../../../../../constants/keys';

const GlobalSearchAutosuggest = props => {
  const {
    placeholder = 'Search',
    name,
    value,
    onEnterPress,
    onSelected,
    onSearchRequested,
    onChange,
  } = props;

  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState(value);
  const timer = useRef(null);

  const getSuggestionValue = useCallback(suggestion => {
    return suggestion.name;
  },[]);

  const renderSuggestion = useCallback((suggestion, { query }) => {
    const nameMatches = AutosuggestHighlightMatch(suggestion.name, query);
    const nameParts = AutosuggestHighlightParse(suggestion.name, nameMatches);

    const descMatches = AutosuggestHighlightMatch(
      suggestion.description,
      query
    );
    const descParts = AutosuggestHighlightParse(
      suggestion.description,
      descMatches
    );

    return (
      <div className='suggestion-item'>
        <div className='sugggestion-item__avatar'>
          <Avatar
            size={40}
            name={suggestion.name}
            image={suggestion.avatar}
            type={suggestion.avatar ? 'default' : suggestion.image}
          />
        </div>
        <div className='sugggestion-item__content'>
          <div className='suggestion-item__name'>
            {nameParts.map((part, index) => {
              const className = part.highlight
                ? 'sugggestion-item-highlight'
                : null;

              return (
                <span className={className} key={index}>
                  {part.text}
                </span>
              );
            })}
          </div>
          <div className='suggestion-item__desc'>
            {descParts.map((part, index) => {
              const className = part.highlight
                ? 'sugggestion-item-highlight'
                : null;

              return (
                <span className={className} key={index}>
                  {part.text}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    );
  }, []);

  const renderSectionTitle = useCallback(section => (
    <div className='suggestion__group'>{section.title}</div>
  ), []);

  const getSectionSuggestions = useCallback(section => section.items, []);

  const onChangeInput = useCallback((event, { newValue }) => {
    setInputValue(newValue);
    onChange(name, newValue);
  }, []);

  const onSuggestionsClearRequested = useCallback(() => {
    setSuggestions([]);
  }, []);

  const onSuggestionSelected = useCallback((event, { suggestion, sectionIndex }) => {
    onSelected(suggestion, suggestions[sectionIndex].group);
  }, [suggestions]);

  const onSuggestionsFetchRequested = useCallback(({ value }) => {
    clearTimeout(timer.current);

    if (value.length > 0) {
      timer.current = setTimeout(() => {
        onSearchRequested(value).then((records = []) => {
          setSuggestions(records);
        });
      }, 500);
    }
  }, [onSearchRequested]);

  const handleKeyUp = useCallback(e => {
    if (KeyCode.ENTER === e.key) {
      onEnterPress();
      setInputValue('');
    }
  }, [onEnterPress]);

  return (
    <Autosuggest
      multiSection={true}
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      renderSectionTitle={renderSectionTitle}
      getSectionSuggestions={getSectionSuggestions}
      onSuggestionSelected={onSuggestionSelected}
      inputProps={{
        placeholder,
        value: inputValue,
        onChange: onChangeInput,
        onKeyUp: handleKeyUp,
      }}
    />
  );
};

GlobalSearchAutosuggest.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onEnterPress: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  onSearchRequested: PropTypes.func.isRequired,
};

export default GlobalSearchAutosuggest;
